<template>
  <div class="company-dialog">
    <b-modal
      id="modalSummariesPrint"
      centered
      modal-class="dialog-700 custom-dialog"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      title="Manifiestos"
    >
      <div class="mt-0 text-center">
        <b-tabs content-class="mt-3">
          <b-tab v-for="(group, index) in groupedSummaries" :key="index">
            <template #title>
              <div class="text-center">
                <span class="font-weight-bold">{{group.carrier}}</span>
              </div>
            </template>
            <div class="col-md-12">
              <p class="highlighted-text mb-1">Manifiesto Nº {{ group.summary_id }} con el Courier {{group.carrier}}</p>
              <iframe width="100%" height="700" :src="group.summary"></iframe>
              <div class="my-1 text-center">
                <span class="mb-1">
                  Si no puedes previsualizar el manifiesto <strong>{{ group.summary_id }}</strong> de {{group.carrier}} haz <a :href="group.summary" class="text-primary" target="_blank">click aquí</a>
                </span>
                <!-- <br>
                <span class="mb-1">
                  Además, si necesitas las etiquetas de los envíos, haz <a :href="group.labels" class="text-primary" target="_blank">click aquí</a>.
                </span> -->
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'modal-summaries-print',
  props: ['groupedSummaries'],
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>
  .highlighted-text {
    font-size: 1rem;
    font-weight: bold;
  }
</style>